/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const BookmarkSimpleOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m18 20.625-6-3.75-6 3.75v-16.5a.751.751 0 0 1 .75-.75h10.5a.751.751 0 0 1 .75.75v16.5z"
})); // Fill


const BookmarkSimpleFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M17.25 2.625H6.75c-.398 0-.779.16-1.061.44-.281.28-.439.66-.439 1.06v16.5a.763.763 0 0 0 .384.66.774.774 0 0 0 .76-.02L12 17.755l5.597 3.51c.115.07.247.11.382.11s.268-.03.387-.09a.767.767 0 0 0 .384-.66v-16.5c0-.4-.158-.78-.439-1.06a1.508 1.508 0 0 0-1.061-.44z"
})); // DuoTone


const BookmarkSimpleDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m18 20.625-6-3.75-6 3.75v-16.5a.751.751 0 0 1 .75-.75h10.5a.751.751 0 0 1 .75.75v16.5z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m18 20.625-6-3.75-6 3.75v-16.5a.751.751 0 0 1 .75-.75h10.5a.751.751 0 0 1 .75.75v16.5z"
}));
/**
  Icon BookmarkSimpleIcon in education group
*/


export const BookmarkSimpleIcon = createIcon('BookmarkSimpleIcon', 'bookmark-simple', 'education', BookmarkSimpleOutline, BookmarkSimpleFill, BookmarkSimpleDuotone, "0 0 24 24");